import { render, staticRenderFns } from "./ContactEventCard.vue?vue&type=template&id=10af17e0&scoped=true"
import script from "./ContactEventCard.vue?vue&type=script&lang=js"
export * from "./ContactEventCard.vue?vue&type=script&lang=js"
import style0 from "./ContactEventCard.vue?vue&type=style&index=0&id=10af17e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af17e0",
  null
  
)

export default component.exports